export default {
  "base": "*:first:mt-0 *:last:mb-0 *:my-1.5"
}